/**
 * Used to compare a birth year with the current year and determine if the person is older than the specified age.
 *
 * @param value Birth year as number or string of numbers
 * @param minAge Minimum age as number
 * @returns True if age is greater than or equal to minAge else false
 */
export var validateAge = function (value, minAge) {
    var selectedBirthYear = Number(value);
    var currentYear = new Date().getFullYear();
    var age = currentYear - selectedBirthYear;
    return age >= minAge;
};
